import React from 'react'
import { connect } from 'react-redux'

import {
  getLoanApplicationState,
  getSidebar,
   } from '../../reducers'

import {
  loanApplicationUserGotoStart
} from '../../actions'

import Section from './Section'

class Sidebar extends React.Component {

  onClick = (state) => {
    this.props.loanApplicationUserGotoStart({
      flow_state: state
    })
  }

  renderSections() {
    let { sidebar } = this.props

    if (sidebar == undefined) {
      return null
    }

    return Object.keys(sidebar.sections).map((key) => (
      <Section
        key={ key }
        active={ sidebar.active }
        completed={ sidebar.completed }
        section={ key }
        onClick= { this.onClick }
        data={ sidebar.sections[key] }
      />
    ))
  }

  render() {
    const { showNavbar } = this.props

    if (!showNavbar) {
      return null
    }

    return(
      <div className="progress-nav fixed-top">
        <ol className="list-group">
          { this.renderSections() }
        </ol>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  loanApplicationState: getLoanApplicationState(state),
  sidebar: getSidebar(state),
  showNavbar: state.settings.showNavbar
})

export default connect(mapStateToProps, {
  loanApplicationUserGotoStart
})(Sidebar)

